import React, { FC } from "react";
import styles from "./MyNavbar.module.css";
import { Link } from "react-router-dom";
import { Stack, Button, ThemeProvider } from "@mui/material";
import { HomeFilled as HomeIcon } from "@mui/icons-material";

import { theme as MyTheme } from "../../config/theme";

interface NavbarProps {}

const MyNavbar: FC<NavbarProps> = () => {
  const items = [
    // { name: "Experience", href: "/experience", disabled: false },
    // {name: "Posts", href: '/', disabled: true},
    { name: "Hobbies", href: "/hobbies", disabled: false },
  ];

  return (
   <ThemeProvider theme={MyTheme}>
    <Stack direction="row" spacing={2} className={`${styles.MyNavbar}`} px={2} py={1} alignItems={'center'}>
      <Button component={Link} to="/" variant="text" startIcon={<HomeIcon /> }>
        Home
      </Button>
      {items.map((item, index)=>(
        <Button key={index} component={Link} to={item.href} color="primary">
          {item.name}
        </Button>
      ))}
    </Stack>
    </ThemeProvider>
  );
};

export default MyNavbar;
